import { useCallback, useEffect, useMemo, useRef, useState } from "react"
import { ErrorCard, LoadingCard, MainContainer, VirtualizeAutoComplete } from "../../components"
import { ENUM_INVOICE_TYPE } from "../creditdebitnote/enum"
import { Button, Autocomplete, AutocompleteItem, Checkbox, Input, Select, SelectItem } from "@nextui-org/react"
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import dayjs from "dayjs"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { apiRoute, ENUM_INPUT_TYPE, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, getModMandatory, getModValue, getModVisiblity, linksUrl } from "../../constants/enum"
import { isMobile } from "react-device-detect"
import { useFetchWithBody, usePost, usePostMutateWithSuccess } from "../../api/reactQueryCustomHooks"
import { useSelector } from "react-redux"
import { faCancel, faFilter, faPlus, faSave, faSquareXmark, faTrashCan } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { DataGrid } from "@mui/x-data-grid"
import { toast } from "react-toastify"
import { useNavigate } from "react-router-dom"
import { Box } from "@mui/material"
import { id } from "date-fns/locale"
import { cleanFilterItem } from "@mui/x-data-grid/hooks/features/filter/gridFilterUtils"
import debounce from 'lodash.debounce';
import Test from "../sample/Test"

const RowsField = {
    id: "id",
    idNo: "idNo",
    takaId: "takaId",
    itemName: "itemName",
    itemCode: "itemCode",
    takaNo: "takaNo",
    takaId: "takaId",
    mcNo: "mcNo",
    pcs: "pcs",
    beamNo: "beamNo",
    meter: "meter",
    weight: "weight",
    avgWeight: "avgWeight",
    kgs: "kgs",
    delFlag: "delFlag",
    mcNoBefore: "mcNoBefore",
}

export const InputCell = ({
    row,
    input_id,
    input_type,
    is_readonly,
    holder_text,
    is_required,
    variant,
    color,
    handleInputChange,
    handleKeyDown,
    hanldeBlur,
}) => {
    const [localValue, setLocalValue] = useState(row[input_id] ?? "");

    useEffect(() => {
        setLocalValue(row[input_id] ?? "");
    }, [row[input_id]]);

    const onBlur = (e) => {
        if (localValue !== row[input_id]) {
            handleInputChange(row.id, { target: { value: localValue, id: RowsField[input_id] } });
        }
        // if (localValue !== row[input_id]) {
        //     const isDuplicate = hanldeBlur(row.id, {
        //         ...e,
        //         target: {
        //             ...e.target,
        //             value: localValue,
        //             id: RowsField[input_id],
        //         },
        //     });
        //     console.log("fg", isDuplicate)
        //     if (isDuplicate) {
        //         setLocalValue(""); // Clear local input immediately
        //         return;
        //     }

        //     handleInputChange(row.id, {
        //         target: { value: localValue, id: RowsField[input_id] },
        //     });
        // } else {
        hanldeBlur(row.id, e);



    };

    return (
        <Input
            isRequired={is_required}
            id={RowsField[input_id]}
            type={input_type}
            size="sm"
            labelPlacement="outside"
            readOnly={is_readonly}
            placeholder={holder_text}
            onKeyDown={(e) => handleKeyDown(row.id, e)}
            value={localValue}
            onChange={(e) => setLocalValue(e.target.value)}
            onBlur={onBlur}
            className="max-w-xs mt-1"
            variant={variant || "bordered"}
            color={color || ""}
        />
    );
};




const CreateProductionEntry = () => {
    const { compCode, appType, startDate, endDate, isMultipleCompany } = useSelector((state) => state.company)
    const { isNewEntry, detailParams } = useSelector((state) => state.production)
    const { user } = useSelector((state) => state.auth);
    const navigate = useNavigate();
    const gridContainerRef = useRef();
    const [modeSettingParams, setModSettingParams] = useState()
    const [selRowIndex, setSelRowIndex] = useState(0)
    const [maxTakaNo, setMaxTakaNo] = useState(0)


    const { isError: isErrorModSet, data: modSetting = [] } = useFetchWithBody({
        url: apiRoute.modeSetting.getModSetting,
        queryKey: "fetchModSetting",
        inputData: {
            mod_name: ENUM_MOD_NAME.GrayProduction
        }
    })

    useEffect(() => {
        let mc_pos = getModValue(ENUM_MOD_PARAMETER.productionEntry.McNoPosition, modSetting);
        setModSettingParams({
            Visibility: {
                //  [RowsField.avgWeight]: getModVisiblity(ENUM_MOD_PARAMETER.productionEntry.Avg_Weight_Kgs, modSetting) ?? false,
                ///  [RowsField.kgs]: getModVisiblity(ENUM_MOD_PARAMETER.productionEntry.Avg_Weight_Kgs, modSetting) ?? false,
                [RowsField.takaNo]: getModVisiblity(ENUM_MOD_PARAMETER.productionEntry.TakaNo, modSetting) ?? false,
                [RowsField.beamNo]: getModVisiblity(ENUM_MOD_PARAMETER.productionEntry.BeamNo, modSetting) ?? false,
                [RowsField.weight]: getModVisiblity(ENUM_MOD_PARAMETER.productionEntry.Weight, modSetting) ?? false,
                [RowsField.mcNo]: getModVisiblity(ENUM_MOD_PARAMETER.productionEntry.McNo, modSetting) ?? false,
            },
            Mandatory: {
                // [RowsField.avgWeight]: getModMandatory(ENUM_MOD_PARAMETER.productionEntry.Avg_Weight_Kgs, modSetting) ?? false,
                // [RowsField.kgs]: getModMandatory(ENUM_MOD_PARAMETER.productionEntry.Avg_Weight_Kgs, modSetting) ?? false,
                [RowsField.takaNo]: getModMandatory(ENUM_MOD_PARAMETER.productionEntry.TakaNo, modSetting) ?? false,
                [RowsField.beamNo]: getModMandatory(ENUM_MOD_PARAMETER.productionEntry.BeamNo, modSetting) ?? false,
                [RowsField.weight]: getModMandatory(ENUM_MOD_PARAMETER.productionEntry.Weight, modSetting) ?? false,
                [RowsField.mcNo]: getModMandatory(ENUM_MOD_PARAMETER.productionEntry.McNo, modSetting) ?? false,
            },
            Value: {
                "mcNoPosition": mc_pos && mc_pos.length > 0 && mc_pos != '' ? mc_pos.toUpperCase() : "",
            }
        })

    }, [modSetting])
    // console.log(modeSettingParams,modSetting)
    const { isLoading, data: masterData = [] } = useFetchWithBody({
        url: apiRoute.production.entryMasterData,
        queryKey: "getMasterData",
        inputData: {
            compcode: compCode.join(",")
        }
    })
    const { data: Chalno = [], mutate: funGenChalNo } = usePost({
        url: apiRoute.production.genNewChalNo,
        queryKey: "gen new chalNoData",
        onSuccessTasks: (data) => {
            if (data && data?.length > 0) {
                setFormData({ ...formData, [formField.challanNo]: data[0].new_chalno })
            }

        }
    })


    let gridData = []
    const onSuccessTasks = (data) => {
        navigate(linksUrl.production.ProdcutionEntryMaster);
    }
    const { isError, isPending, mutate: funAddUpdate } = usePost({
        url: apiRoute.production.add_update,
        queryKey: "funAddUpdateProduction",
        onSuccessTasks
    })

    const { isError: isErrorDetail, data: detail = [], mutate: funGetDetail } = usePost({
        url: apiRoute.production.fetchEntryDetail,
        queryKey: "fetchProductionDetail",
    });
    const onSuccessMchnData = (data) => {

        if (data && data.length > 0) {
            const index = rows.findIndex(ele => ele.id == selRowIndex)
            if (index >= 0) {
                setRows((prev) => {
                    const newRows = [...prev]
                    const updateRow = {
                        ...newRows[index], [RowsField.itemCode]: data[0].Item_Code,
                        [RowsField.itemName]: data[0].Item_Name,
                        [RowsField.beamNo]: data[0].BeamNo
                    }
                    newRows[index] = updateRow
                    return newRows

                })
            }
        }

    }
    const { data: machinData = [], mutate: funGetMchnData } = usePost({
        url: apiRoute.production.getMachineData,
        queryKey: "fetchMachineDetail",
        onSuccessTasks: onSuccessMchnData
    });
    const onSuccessMaxTakaNo = (data) => {
        if (data && data.length > 0) {
            setMaxTakaNo(data[0].MaxTakaNo)
            funGenGridRows(1, data[0].MaxTakaNo)
        }
    }
    const { data: maxTakaNoData = [], mutate: funGetMaxtakaNo } = usePost({
        url: apiRoute.production.getMaxTakaNo,
        queryKey: "fetchMaxTakaNo",
        onSuccessTasks: onSuccessMaxTakaNo
    });

    useEffect(() => {
        if (startDate && startDate != "" && startDate != null && endDate && endDate != "" && endDate != null) {
            if (isMultipleCompany)
                navigate(linksUrl.dashboard.tradingDashboard)
            if (isNewEntry) {
                funGenChalNo({
                    data: {
                        comp_code: compCode.join(","),
                        start_date:dayjs(startDate).format("YYYY-MM-DD"),
                        end_date:dayjs(endDate).format("YYYY-MM-DD")
                    }
                })
            }
            if (!isNewEntry && detailParams && Object.keys(detailParams).length > 0) {
                const { comp_code, chal_no, rp_id } = detailParams
                funGetDetail({
                    data: {
                        compcode: comp_code,
                        chalno: chal_no,
                        rpid: rp_id
                    }
                })
            }
        }

    }, [])

    const { mutate: funchkTakaNo } = usePostMutateWithSuccess({
        url: apiRoute.production.checkTakaNo,
        queryKey: "funcheck  Duplicate takaNo",

    })
    const onSuccessChkChalNo = (data) => {

        if (data && data.length > 0) {
            setFormData({ ...formData, [formField.challanNo]: "" })
            toast.error("Chall No Exist Enter Another", {
                "position": "top-center"
            })
        }
    }
    const { mutate: funchkChalNo } = usePost({
        url: apiRoute.production.checkChalNo,
        queryKey: "funcheck  Duplicate ChalNo",
        onSuccessTasks: onSuccessChkChalNo
    })
    const [deletedItemRows, setDeletedItemRows] = useState([])
    const [NoOftaka, setNoOfTaka] = useState()

    const formField = {
        recAcId: "recAcId",
        recAcName: "recAcName",
        challanNo: "challanNo",
        challanDate: "challanDate",
        unitId: "unitId",
        unitName: "unitName",
        qualityId: "qualityId",
        qualityName: "qualityName"

    }
    const [rows, setRows] = useState([])



    const initialRow = {
        [RowsField.idNo]: 0,
        [RowsField.itemCode]: "",
        [RowsField.itemName]: "",
        [RowsField.takaNo]: "",
        [RowsField.takaId]: 0,
        [RowsField.pcs]: "",
        [RowsField.mcNo]: "",
        [RowsField.beamNo]: "",
        [RowsField.meter]: 0,
        [RowsField.weight]: 0,
        [RowsField.avgWeight]: 0,
        [RowsField.kgs]: 0,
        [RowsField.delFlag]: 0
    }

    const emptyFormField = Object.keys(formField).reduce((acc, key) => {
        if (key == formField.challanDate)
            acc[key] = new Date()
        else acc[key] = ""
        return acc
    }, {})

    const [formData, setFormData] = useState({
        ...emptyFormField
    })

    const inputBoxes = {
        Row1: [
            {
                id: formField.recAcId,
                name: formField.recAcId,
                placeholder: "Rec From",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: masterData && masterData?.unitMaster ? masterData?.unitMaster : [],
                itemkey: "Party_Id",
                itemvalue: "Party_Name",
                isrequired: true,
            }],
        Row2: [
            {
                id: formField.challanNo,
                name: formField.challanNo,
                placeholder: "Challan No",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: true,
            },
            {
                id: formField.challanDate,
                name: formField.challanDate,
                placeholder: "challan Date",
                type: ENUM_INPUT_TYPE.date,
                size: "sm",
                label: "",
                isrequired: false,
            }

        ],
        Row3: [{
            id: formField.unitId,
            name: formField.unitId,
            placeholder: "Unit Name",
            type: ENUM_INPUT_TYPE.autocomplete,
            size: "sm",
            label: "",
            data: masterData && masterData?.unitMaster ? masterData?.unitMaster : [],
            itemkey: "Party_Id",
            itemvalue: "Party_Name",
            isrequired: true,
        },
        {
            id: formField.qualityId,
            name: formField.qualityId,
            placeholder: "Quality",
            type: ENUM_INPUT_TYPE.autocomplete,
            size: "sm",
            label: "",
            data: masterData && masterData?.itemMaster ? masterData?.itemMaster : [],
            itemkey: "Item_Code",
            itemvalue: "Item_Desc",
            isrequired: false,
        }
        ]

    }

    const funGetDupChalNo = (rec_id, chal_no) => {
        if (rec_id != "" && chal_no != "") {
            funchkChalNo({
                data: {
                    compcode: compCode.join(","),
                    chal_no: chal_no,
                    rp_id: rec_id,
                    start_date:dayjs(startDate).format("YYYY-MM-DD"),
                    end_date:dayjs(endDate).format("YYYY-MM-DD")
                }
            })
        }
    }

    // const handleInputChange = useCallback((rowId, e, name) => {

    //     let { value, id } = e.target
    //     let index = rows.findIndex(ele => ele.id == rowId)

    //     setRows((prevData) => {
    //         const newData = [...prevData];
    //         const updatedArray = { ...newData[index], [id]: value };
    //         newData[index] = updatedArray;
    //         return newData
    //     })

    // })


    const debouncedUpdaterRef = useRef(null);

    const handleInputChange = useCallback((rowId, e) => {
        const { value, id } = e.target;

        if (!debouncedUpdaterRef.current) {
            debouncedUpdaterRef.current = debounce((rowId, id, value) => {
                setRows((prevData) => {
                    const index = prevData.findIndex((row) => row.id === rowId);
                    if (index === -1) return prevData;
                    const newData = [...prevData];
                    newData[index] = { ...newData[index], [id]: value };
                    return newData;
                });
            }, 50); // 300ms delay
        }

        debouncedUpdaterRef.current(rowId, id, value);
    }, []);


    console.log(rows)
    const funGridSetting = (value, id, index) => {

        if (id == RowsField.mcNo && modeSettingParams.Visibility[RowsField.beamNo]) {

            funGetMchnData({
                data: {
                    compcode: compCode.join(","),
                    mcno: value
                }
            })

        }
        let rowId = RowsField.takaNo
        if (modeSettingParams && Object.keys(modeSettingParams).length > 0) {
            if (modeSettingParams.Visibility && Object.keys(modeSettingParams.Visibility).length > 0) {

                if (modeSettingParams.Visibility[RowsField.mcNo] && modeSettingParams.Value.mcNoPosition != "BEFORE")
                    rowId = RowsField.mcNo
                if (modeSettingParams.Visibility[RowsField.beamNo])
                    rowId = RowsField.beamNo
                if (modeSettingParams.Visibility[RowsField.weight])
                    rowId = RowsField.avgWeight

            }

        }
        if (id == rowId) {
            if (index == rows.length) {
                if (maxTakaNo == "0") {
                    funGetMaxtakaNo({
                        data: {
                            compcode: compCode.join(",")
                        }
                    })
                }
                else {
                    funGenGridRows(1, 0);
                }
                //                funGenGridRows(1, maxTakaNo)
                const gridScroller = document.querySelector('.MuiDataGrid-virtualScroller');
                const gridp = document.querySelector('.MuiDataGrid-columnHeaders');
                gridp.position = "fixed"
                if (gridScroller) {
                    gridScroller.scrollLeft = 0; // Scroll to the left
                }
            }
        }
    }

    const handleKeyDown = (index, event, name) => {
        setSelRowIndex(index)
        // if (event.key === "Enter")
        // event.preventDefault()

        if (event.key === 'Tab') {
            const { value, id } = event.target
            funGridSetting(value, id, index)


        }
        else {
            if (['Space', 'ArrowLeft', 'ArrowRight'].includes(event.code)) {
                return; // Do nothinghanldeBlur
            } else {
                event.stopPropagation(); // Prevent other keys from propagating
            }
        }
    };

    const hanldeBlur = (rowid, e) => {
        const { value, id, name } = e.target
        let isCheckInDb = 0


        if (id == RowsField.takaNo) {
            let isdup = false

            const sel = rows?.find((item) => item?.takaNo == value && item?.id != rowid) || 0;

            if (sel) {
                const index = rows.findIndex((ele) => ele.id == rowid)
                setRows((prev) => {
                    const newRows = [...prev]
                    const updateRow = { ...newRows[index], [RowsField.takaNo]: "" }
                    newRows[index] = updateRow
                    return newRows
                })
                toast.error("Taka no. '" + value + "' Exists Enter Another", {
                    "position": "top-center"
                })
            }
            funchkTakaNo({
                data: {
                    compcode: compCode.join(","),
                    taka_no: value
                },
                onSuccess: (data) => {

                    if (data && data.length > 0) {
                        const index = rows.findIndex((ele) => ele.id == rowid && ele.idNo != data[0].IdNo)
                        isdup = true

                        if (index >= 0) {
                            setRows((prev) => {
                                const newRows = [...prev]
                                const updateRow = { ...newRows[index], [RowsField.takaNo]: "" }
                                newRows[index] = updateRow
                                return newRows
                            })
                            toast.error("Taka no. '" + data[0].Taka_No + "' Exists Enter Another", {
                                "position": "top-center"
                            })
                        }
                        return true;
                    }
                }
            })

        }
        // else if (name == formField.challanNo) {
        //     funGetDupChalNo(formData[formField.recAcId], value)
        // }
        if (isMobile) {
            setSelRowIndex(rowid)
            funGridSetting(value, id, rowid)
        }
        // return false
    }


    // const renderInputCell = useCallback((row, input_id, input_type, is_readonly, holder_text, is_required, variant, color) => {

    //     return (
    //         <Input
    //             isRequired={is_required}
    //             id={RowsField[input_id]}
    //             type={input_type}
    //             size="sm"
    //             // label=""
    //             labelPlacement="outside"
    //             readOnly={is_readonly}
    //             placeholder={holder_text}
    //             onKeyDown={(e) => handleKeyDown(row.id, e,)}
    //             defaultValue=""

    //             value={row[input_id]}
    //            onChange={(e) => handleInputChange(row.id, e)}
    //            // onChange={(e) => handleInputChange(row.id, e, "")}
    //             onBlur={(e) => hanldeBlur(row.id, e)}
    //             className="max-w-xs mt-1"
    //             variant={variant ? variant : "bordered"}
    //             color={color ? color : ""}
    //         ></Input>
    //     )
    // }, [handleInputChange]);

    const itemGridHeadClass = "bill-grid-style"

    const columns = [
        {
            field: RowsField.id,
            headerName: "No.",
            width: 30,
            headerAlign: "center",
            align: "center",
            headerClassName: itemGridHeadClass,
            disableColumnMenu: true,
            renderCell: ({ row }) => (
                <strong>
                    {row.id}
                </strong>
            ),
        },
        {
            field: RowsField.idNo,
            headerName: "Delete",
            width: 70,
            headerAlign: "center",
            align: "center",
            headerClassName: itemGridHeadClass,
            disableColumnMenu: true,
            renderCell: ({ row }) => (
                <strong>
                    <FontAwesomeIcon
                        color="red"
                        className="cursor-pointer text-md"
                        onClick={() => handleDeleteRow(row.id, row[RowsField.delFlag])}
                        icon={faSquareXmark}

                    ></FontAwesomeIcon>
                </strong>
            ),
        },
        {
            field: RowsField.mcNoBefore,
            headerName: "mc no",
            width: 100,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,

            renderCell: ({ row }) =>
                <InputCell
                    row={row}
                    input_id={RowsField.mcNo}
                    input_type="text"
                    is_readonly={false}
                    holder_text="Enter Taka No"
                    is_required={true}
                    variant="bordered"
                    color="primary"
                    handleInputChange={handleInputChange}
                    handleKeyDown={handleKeyDown}
                    hanldeBlur={hanldeBlur}
                />
            //renderInputCell(row, RowsField.mcNo, "text", false, "", false, "", ""),
        },
        {
            field: RowsField.itemCode,
            headerName: "Quality Code",
            width: 100,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            disableColumnMenu: true,
            renderCell: ({ row }) =>
                <InputCell
                    row={row}
                    input_id={RowsField.itemCode}
                    input_type="text"
                    is_readonly={true}
                    holder_text=""
                    is_required={false}
                    variant="bordered"
                    color="primary"
                    handleInputChange={handleInputChange}
                    handleKeyDown={handleKeyDown}
                    hanldeBlur={hanldeBlur}
                />
            //renderInputCell(row, RowsField.itemCode, "text", true, "", false, "", ""),

        },
        {
            field: RowsField.itemName,
            headerName: "Quality Name",
            width: 200,
            //isVisible:true,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <Autocomplete
                    isRequired
                    size="sm"
                    id={RowsField.itemName}
                    eventResizeFeature={true}
                    selectionMode="single"
                    showScrollIndicators={true}
                    placeholder="--Select--"
                    className="max-w-23"
                    isLoading={isLoading}
                    isClearable={false}
                    readOnly={rows[RowsField.delFlag]}
                    isVirtualized
                    value={row.itemName}
                    menuTrigger={"input"}
                    defaultItems={
                        masterData && masterData.itemMaster ? masterData?.itemMaster : []
                    }
                    onSelectionChange={(e) =>
                        handleAutoCompleteChange(e, row.id)
                    }
                    selectedKey={row.itemCode}
                    color={"success"}
                    variant="flat"
                >
                    {(item) => (
                        <AutocompleteItem
                            key={item.Item_Code}
                        >
                            {item.Item_Code + "(" + item.Item_Desc + ")"}
                        </AutocompleteItem>
                    )}
                </Autocomplete>


            ),
        },
        {
            field: RowsField.takaNo,
            headerName: "Taka No",
            minWidth: 150,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                <InputCell
                    row={row}
                    input_id={RowsField.takaNo}
                    input_type="text"
                    is_readonly={false}
                    holder_text="Enter Taka No"
                    is_required={true}
                    variant="bordered"
                    color="primary"
                    handleInputChange={handleInputChange}
                    handleKeyDown={handleKeyDown}
                    hanldeBlur={hanldeBlur}
                />
            //renderInputCell(row, RowsField.takaNo, "text", false, "", true, "", ""),
        },
        {
            field: RowsField.mcNo,
            //modSetting&& modeSettingParams&& modeSettingParams.Value.mcNoPosition != "BEFORE" ? RowsField.mcNo : RowsField.mcNoBefore,
            headerName: "MCNo",
            minWidth: 80,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => <InputCell
                row={row}
                input_id={RowsField.mcNo}
                input_type="text"
                is_readonly={false}
                holder_text=""
                is_required={false}
                variant="bordered"
                color="primary"
                handleInputChange={handleInputChange}
                handleKeyDown={handleKeyDown}
                hanldeBlur={hanldeBlur}
            />// renderInputCell(row, RowsField.mcNo, "text", false, "", false, "", ""),
        },
        {
            field: RowsField.beamNo,
            headerName: "Beam No",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                <InputCell
                    row={row}
                    input_id={RowsField.beamNo}
                    input_type="text"
                    is_readonly={false}
                    holder_text=""
                    is_required={false}
                    variant="bordered"
                    color="primary"
                    handleInputChange={handleInputChange}
                    handleKeyDown={handleKeyDown}
                    hanldeBlur={hanldeBlur}
                />
            // renderInputCell(row, RowsField.beamNo, "text", false, "", false, "", ""),
        },
        {
            field: RowsField.meter,
            headerName: "Meter",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                <InputCell
                    row={row}
                    input_id={RowsField.meter}
                    input_type="number"
                    is_readonly={false}
                    holder_text=""
                    is_required={true}
                    variant="bordered"
                    color="primary"
                    handleInputChange={handleInputChange}
                    handleKeyDown={handleKeyDown}
                    hanldeBlur={hanldeBlur}
                />
            // renderInputCell(row, RowsField.meter, "number", false, "", true, "", ""),
        },

        {
            field: RowsField.weight,
            headerName: "Weight",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                <InputCell
                    row={row}
                    input_id={RowsField.weight}
                    input_type="number"
                    is_readonly={false}
                    holder_text=""
                    is_required={false}
                    variant="bordered"
                    color="primary"
                    handleInputChange={handleInputChange}
                    handleKeyDown={handleKeyDown}
                    hanldeBlur={hanldeBlur}
                />
            // renderInputCell(row, RowsField.weight, "number", false, "", false, "", ""),

        },
        {
            field: RowsField.avgWeight,
            headerName: " Avg Weight",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                <InputCell
                    row={row}
                    input_id={RowsField.avg}
                    input_type="number"
                    is_readonly={false}
                    holder_text=""
                    is_required={false}
                    variant="bordered"
                    color="primary"
                    handleInputChange={handleInputChange}
                    handleKeyDown={handleKeyDown}
                    hanldeBlur={hanldeBlur}
                />
            // renderInputCell(row, RowsField.avgWeight, "number", false, "", false, "", ""),

        },
        {
            field: RowsField.kgs,
            headerName: " +/- Kgs",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                <InputCell
                    row={row}
                    input_id={RowsField.kgs}
                    input_type="number"
                    is_readonly={false}
                    holder_text=""
                    is_required={false}
                    variant="bordered"
                    color="primary"
                    handleInputChange={handleInputChange}
                    handleKeyDown={handleKeyDown}
                    hanldeBlur={hanldeBlur}
                />
            //    renderInputCell(row, RowsField.kgs, "number", false, "", false, "", ""),

        },

    ]

    const handleChange = (e) => {
        const { name, value } = e.target

        setFormData({ ...formData, [name]: value })
    }

    const handleAutoCompleteChange = (value, rowid, name) => {
        if (name == formField.recAcId || name == formField.unitId || name == formField.qualityId) {

            if (name == formField.recAcId) {
                let t_unitId = formData[formField.unitId]
                if (formData[formField.unitId] == "" || formData[formField.unitId] == null)
                    t_unitId = value
                //   funGetDupChalNo(value, formData[formField.challanNo])
                setFormData({
                    ...formData,
                    [name]: value,
                    [formField.unitId]: t_unitId
                })
            }
            else
                setFormData({
                    ...formData,
                    [name]: value,
                })
        }
        else {
            const index = rows.findIndex((ele) => ele.id == rowid)
            const tempdata = masterData.itemMaster
            const itemData = tempdata.filter((ele) => ele.Item_Code == value)
            if (itemData && itemData.length > 0) {
                setRows((prevData) => {
                    const newData = [...prevData];
                    const updatedArray = { ...newData[index], [RowsField.itemCode]: value }
                    newData[index] = updatedArray;
                    return newData
                })
            }
        }
    }
    const funGenGridRows = (no_ofrows, p_maxTakaNo) => {
        let max_takano = ""
        let t_itemCode = ""
        let t_itemName = ""

        // if (masterData && masterData.maxTakaNo && masterData.maxTakaNo.length > 0) {
        //  max_takano = masterData.maxTakaNo[0]["MaxTakaNo"]
        //  }
        if (p_maxTakaNo != "0") {
            max_takano = p_maxTakaNo
        }

        let tempData = [];
        let row_length = rows.length

        if ((rows.length > 0 && isNewEntry) || (!isNewEntry && rows.length >= detail.length)) {

            if (p_maxTakaNo == "0") {

                //console.log(typeof(rows[row_length - 1][RowsField.takaNo]))
                max_takano = Number(rows[row_length - 1][RowsField.takaNo]);

                if (Number(max_takano) <= Number(maxTakaNo))
                    max_takano = maxTakaNo
            }
            //if(index==)
            t_itemName = String(rows[row_length - 1][RowsField.itemName]);
            t_itemCode = String(rows[row_length - 1][RowsField.itemCode]);
        }
        for (let i = 0; i < no_ofrows; i++) {
            ++row_length;
            let newRow;
            // if (isSameQuality)
            // newRow = {
            //     id: row_length, ...initialRow, [RowsField.takaNo]: max_takano++,
            //     [RowsField.itemCode]: formData[formField.qualityId],
            //     [RowsField.itemName]: formData[formField.qualityName]
            // }
            //else
            //console.log(rows.length,"f",no_ofrows)
            if (no_ofrows == 1 && formData[formField.qualityId] != "" && formData[formField.qualityId] != null)
                t_itemCode = formData[formField.qualityId]
            newRow = {
                id: row_length, ...initialRow, [RowsField.takaNo]: Number(max_takano) + 1,
                [RowsField.itemCode]: String(t_itemCode), [RowsField.itemName]: String(t_itemName)

            }
            tempData = [...tempData, newRow]
        }

        setRows([...rows, ...tempData])
    }

    const handleNoOftakaChange = () => {
        if (NoOftaka && NoOftaka > 0 && NoOftaka != "")
            funGenGridRows(NoOftaka, 0)
    }

    const ValidateGrid = () => {
        let no = 0
        let msg = ""
        if (rows.length > 0) {
            for (let i = 0; i < rows.length; i++) {

                if (rows[i].itemCode == "" || rows[i].itemCode == "0") {
                    if (!msg.includes("Quality"))
                        msg = msg + "  Quality ,";
                    no = 1
                }
                if (rows[i].meter == "" || rows[i].meter == "0") {
                    if (i != rows.length - 1) {
                        if (!msg.includes("Meter"))
                            msg = msg + "  Meter ,";
                        no = 1
                    }
                    // if(i==rows.length-1)
                    // {
                    // //    const newData= rows.filter(ele=>ele.id!=rows[rows.length-1].id)
                    // //     setRows(newData)
                    // }
                }
            }
        }
        else {
            msg = "Add Atleast One  Item"
            no = 1
        }
        if (no)
            return msg + " is required"
        else return ""
    }

    const [errors, setErrors] = useState({})

    const validateForm = () => {
        const newErrors = {}

        // Validate username
        // if (formData.challanNo.trim() == "") {
        //     newErrors[formField.challanNo] = "Challan No is required"
        // }

        if (formData[formField.recAcId].trim() === "" || formData[formField.recAcId] == "0") {
            newErrors[formField.recAcId] = "Rec From is required"
        }

        if (formData[formField.unitId].trim() == "" || formData[formField.unitId] == "0") {
            newErrors[formField.unitId] = "Unit is required"
        }

        setErrors(newErrors)

        // Return true if there are no errors
        return Object.keys(newErrors).length === 0
    }

    useEffect(() => {
        validateForm();
    }, [formData])

    const handleSubmit = (e) => {
        e.preventDefault()

        const grid_msg = ValidateGrid();
        const validate_form = validateForm()
        if (grid_msg == "" && validate_form) {
            let rowData = rows;
            if (rows.length > 1) {
                let last_inx = rows.length - 1
                if (rows[last_inx].meter == "0" || rows[last_inx - 1].meter == "") {
                    rowData = rows.slice(0, last_inx)
                }
            }
            funAddUpdate({
                data: {
                    comp_code: compCode.join(","),
                    item_list: rowData,
                    deleteditem_list: deletedItemRows,
                    rec_status: !isNewEntry ? 1 : 2,
                    inward_type: "I",
                    challan_no: formData.challanNo,
                    challan_date: formData.challanDate,
                    rac_id: formData.recAcId,
                    unit_id: formData.unitId,
                    pdate: formData.challanDate,
                    quality_code: formData.qualityId,
                    login_userid: user.username,
                }
            })
        }
        else {
            toast.error(grid_msg, {
                "position": "top-center"
            })
        }

    }

    const handleDeleteRow = (id, del_flag) => {
        if (!del_flag) {
            const updatedRows = rows.filter((row) => row.id !== id)
            let DeletedRow = rows.filter((row) => row.id == id)
            setRows(updatedRows)
            setDeletedItemRows([...deletedItemRows, ...DeletedRow])
        }
        else {
            toast.error("Taka No already dispatched or in used can't be delete", {
                "position": "top-center"
            })
        }
    }

    if (!isNewEntry) {
        if (detailParams && Object.keys(detailParams).length > 0) {
            if (detail && detail?.length > 0) {
                gridData = detail?.map((item, i) => {

                    return {
                        id: ++i,
                        [RowsField.idNo]: item?.idno ?? 0,
                        [RowsField.takaId]: item?.takaid ?? 0,
                        [RowsField.itemName]: item?.item_name ?? "",
                        [RowsField.itemCode]: item?.item_code ?? "",
                        [RowsField.takaNo]: item?.takano ?? "",
                        [RowsField.takaId]: item?.takaid ?? 0,
                        [RowsField.mcNo]: item?.mcno ?? "",
                        [RowsField.pcs]: item?.pcs ?? "",
                        [RowsField.beamNo]: "",
                        [RowsField.meter]: item?.meter ?? 0,
                        [RowsField.weight]: item?.weight ?? 0,
                        [RowsField.avgWeight]: 0,
                        [RowsField.kgs]: "",
                        [RowsField.delFlag]: item?.delflag ?? 0
                    }
                })
            }
        }
    }

    const hanldeCheckChange = (event) => {

        if (formData.qualityId != "" && formData.qualityId != "0") {
            //  setIsSameQuality(event.target.checked)
        }
        else {
            //  setIsSameQuality(false)
            toast.error("select Quality", {
                "position": "top-center"
            })
        }
    }


    useEffect(() => {
        if (!isNewEntry && detailParams && Object.keys(detailParams).length > 0) {
            setRows(gridData)

            if (detail && detail.length > 0) {
                setFormData({
                    ...formData,
                    challanNo: detail[0]?.chal_no ?? "",
                    challanDate: detail[0]?.chal_date ?? null,
                    recAcId: detail[0]?.rp_id ?? "",
                    recAcName: detail[0]?.rec_party ?? "",
                    unitId: detail[0]?.lac_id ?? "",
                    unitName: detail[0]?.unit_name ?? "",
                })
            }
        }

    }, [detail])
    const handleClickPrev = () => {
        navigate(linksUrl.production.ProdcutionEntryMaster)
    }
    const handleAddRow = () => {
        if (maxTakaNo == "0") {
            funGetMaxtakaNo({
                data: {
                    compcode: compCode.join(",")
                }
            })
        }
        else {
            funGenGridRows(1, 0);
        }
    }


    if (isPending) {
        return <LoadingCard />;
    }
    if (isError || isErrorDetail) {
        return <ErrorCard />;
    }

    return (
        <div>
            <MainContainer
                pageName={`${isNewEntry ? "New" : "Update"} Gray Production Entry `}
                breadcrumbs={["Transaction", "Gray Production Entry"]}
                prevPage={{
                    show: true,
                    onClick: handleClickPrev,
                }}
            >

                <div shadow="sm" className="mb-3 w-full">
                    {/* <Test /> */}
                    <form onSubmit={handleSubmit} autoComplete='off'>
                        {
                            Object.keys(inputBoxes).map((key, ind) => (
                                <div key={key + ind}>
                                    <div className={` ${isMobile ? 'flex-wrap' : ''}   flex gap-4 align-top items-baseline mb-2 `}>
                                        {
                                            inputBoxes[key].map((item, indx) =>
                                                item.type == ENUM_INPUT_TYPE.select ? (
                                                    <></>
                                                ) : item.type == ENUM_INPUT_TYPE.autocomplete ? (
                                                    <Autocomplete
                                                        size="md"
                                                        name={item.name}
                                                        isInvalid={errors[item.name]}
                                                        errorMessage={errors[item.name]}
                                                        label={item?.placeholder}
                                                        eventResizeFeature={true}
                                                        selectionMode="single"
                                                        showScrollIndicators={true}
                                                        labelPlacement={"outside"}
                                                        placeholder={item.placeholder}
                                                        isRequired={item.isrequired}
                                                        isLoading={isLoading}
                                                        className="max-w-23"
                                                        classNames={{
                                                            label: "text-xs text-black font-bold",
                                                        }}
                                                        isClearable={false}
                                                        isVirtualized
                                                        isReadOnly={isNewEntry ? false : true}
                                                        defaultItems={
                                                            item.data ? item.data : []
                                                        }
                                                        onSelectionChange={(e) =>
                                                            handleAutoCompleteChange(e, "", item.name)
                                                        }
                                                        color={item.id == formField.recAcId ? "warning" : item.id == formField.partyId ? "primary" : ""}
                                                        //onChange={handleFormSelectionChange}
                                                        selectedKey={formData[item.name]}
                                                    >
                                                        {(list) => (
                                                            <AutocompleteItem

                                                                key={list[item.itemkey]}
                                                            >
                                                                {list[item.itemvalue]}
                                                            </AutocompleteItem>
                                                        )}
                                                    </Autocomplete>


                                                ) : item.type == ENUM_INPUT_TYPE.date ? (
                                                    <div className=" w-full flex items-center">
                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                            <DatePicker
                                                                label={item.placeholder}
                                                                views={["day", "month", "year"]}
                                                                format="DD/MM/YYYY"
                                                                value={
                                                                    formData[item.name]
                                                                        ? dayjs(formData[item.name])
                                                                        : formData[item.name]
                                                                }
                                                                onChange={(newValue) => {
                                                                    setFormData((prev) => {
                                                                        return {
                                                                            ...prev,
                                                                            [item.name]:
                                                                                dayjs(newValue).format("YYYY-MM-DD"),

                                                                        };
                                                                    });
                                                                }}
                                                                //isRequired={item.required}
                                                                className="w-full "
                                                                slotProps={{
                                                                    textField: { size: "small", required: true },
                                                                }}
                                                            />
                                                        </LocalizationProvider>
                                                    </div>
                                                ) : (
                                                    <Input
                                                        type={item.type}
                                                        name={item.name}
                                                        id={item.name}
                                                        isInvalid={errors[item.name]}
                                                        errorMessage={errors[item.name]}
                                                        //aria-label={item.placeholder}
                                                        placeholder={item.placeholder}
                                                        label={item.placeholder}
                                                        labelPlacement="outside"
                                                        isRequired={item.isrequired}
                                                        value={formData[item.name]}
                                                        variant="bordered"
                                                        disabled={isNewEntry ? false : true}
                                                        onChange={(e) => handleChange(e)}
                                                        onBlur={(e) => hanldeBlur("", e)}
                                                        isReadOnly={item.name == formField.challanNo ? true : false}
                                                        //  readOnly={item.name == formField.voucherNo ? true : false}
                                                        size={"md"}
                                                        classNames={{
                                                            label: "text-xs text-black font-bold",
                                                        }}
                                                    ></Input>
                                                )
                                            )
                                        }
                                    </div>

                                </div>

                            ))
                        }
                        <div className="mt-5">
                            <div>
                                <Button size="sm" color="success" className="text-white" startContent={<FontAwesomeIcon color="white" icon={faPlus} />} variant="shadow" onClick={handleAddRow}>
                                    Add Taka
                                </Button>
                            </div>
                            {rows && rows?.length > 0 ? (
                                //overflow-y-auto scrollbar  max-h-48 
                                <Box sx={{
                                    height: rows.length > 10 ? 550 : "auto", width: '100%',


                                }}>
                                    {/* style={{ height: 50+ Number(rows.length * 51), width: "100%", maxHeight: "500px", overflow: "auto" }}> */}
                                    <DataGrid
                                        ref={gridContainerRef}
                                        rows={rows}
                                        columns={columns}
                                        editMode="row"
                                        hideFooterPagination={rows && rows.length > 100 ? false : true}
                                        hideFooter={rows && rows.length > 100 ? false : true}
                                        columnHeaderHeight={35}
                                        disableColumnMenu={false}
                                        rowHeight={45}
                                        sx={{
                                            '& .MuiDataGrid-columnHeaders': {
                                                position: 'sticky',
                                                top: 0,
                                                fontWeight: "bold",
                                                zIndex: 1, // Make sure the headers are above the rows when scrolling

                                            },
                                            '& .MuiDataGrid-menuIcon': {
                                                visibility: 'visible',
                                                opacity: 1,
                                                width: 'auto',
                                            },
                                            // '& .MuiDataGrid-menuIcon button': {

                                            //     backgroundColor: "#ffffff",
                                            // },
                                            '& .MuiDataGrid-menuIcon svg': {
                                                color: '#fffcfcff',

                                            },

                                        }}
                                        disableColumnSorting={true}

                                        columnVisibilityModel={{
                                            [RowsField.itemCode]: formData && formData[formField.qualityId] != "" && formData[formField.qualityId] != null ? false : true,
                                            [RowsField.itemName]: formData && formData[formField.qualityId] != "" && formData[formField.qualityId] != null ? false : true,
                                            [RowsField.mcNo]: modSetting && modSetting.length > 0 ? modeSettingParams.Value.mcNoPosition != "BEFORE"
                                                && modeSettingParams.Visibility[RowsField.mcNo] ? true : false : true,
                                            [RowsField.mcNoBefore]: modSetting && modSetting.length > 0 ? modeSettingParams.Visibility[RowsField.mcNo]
                                                && modeSettingParams.Value.mcNoPosition == "BEFORE" ? true : false : false,
                                            [RowsField.beamNo]: modSetting && modSetting.length > 0 ? modeSettingParams.Visibility[RowsField.beamNo] : true,
                                            [RowsField.weight]: modSetting && modSetting.length > 0 ? modeSettingParams.Visibility[RowsField.weight] : true,
                                            [RowsField.avgWeight]: modSetting && modSetting.length > 0 ? modeSettingParams.Visibility[RowsField.weight] : true,
                                            [RowsField.kgs]: modSetting && modSetting.length > 0 ? modeSettingParams.Visibility[RowsField.weight] : true,
                                        }}
                                    />
                                </Box>
                            ) : (
                                ""
                            )}
                        </div>
                        <div className="justify-center flex gap-5 mt-5">
                            <Button
                                color="primary"
                                type="submit"
                                size="md"
                                variant="shadow"
                                tabIndex={-1}
                                startContent={<FontAwesomeIcon icon={faSave} />}
                            >
                                Submit
                            </Button>
                            <Button
                                color="danger"
                                variant="shadow"
                                size="md"
                                tabIndex={-1}
                                onClick={handleClickPrev}
                                startContent={<FontAwesomeIcon icon={faCancel} />}
                            >
                                Cancel
                            </Button>
                        </div>
                    </form>
                </div>
            </MainContainer>
        </div>
    )

}
export default CreateProductionEntry